/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-empty-pattern */

import clsx from 'clsx';
import { HTMLAttributes } from 'react';

export type BottomNavigationProps = HTMLAttributes<HTMLDivElement>;

/**
 * @component BottomNavigation
 */
function BottomNavigation({
  className,
  style,
  children,
  ...rest
}: BottomNavigationProps) {
  const rootClasses = clsx(
    `fixed bottom-0 w-full h-12 bg-white flex z-[999] px-6 sm:px-16`,
    className,
  );
  return (
    <div
      className={rootClasses}
      style={{ boxShadow: `4px 1px 12px rgba(98, 98, 98, 0.26)`, ...style }}
      {...rest}
    >
      {children}
    </div>
  );
}

export default BottomNavigation;
